import {Pipe, PipeTransform} from '@angular/core';

/** What a failed process recorded about its error in `data` (a JSON string), next to its `message`. */
export interface ProcessFailureDetail {
  /** The error type, e.g. `WorkflowException`; absent when unknown. */
  errorType?: string;
  /** The recorded error message, only when it says more than the process `message` already does. */
  detail?: string;
}

/** Messages that name a failure without explaining it; `detail` replaces them rather than repeating them. */
const GENERIC_MESSAGES = new Set(['', 'States.TaskFailed', 'States.ALL']);

export function processFailureDetail(data: string | null | undefined, message: string | null | undefined): ProcessFailureDetail {
  let parsed: unknown;
  try {
    parsed = data ? JSON.parse(data) : null;
  } catch {
    return {};
  }
  if (!parsed || typeof parsed !== 'object') {
    return {};
  }
  const {errorType, errorMessage} = parsed as {errorType?: unknown; errorMessage?: unknown};
  const result: ProcessFailureDetail = {};
  if (typeof errorType === 'string' && errorType) {
    result.errorType = errorType;
  }
  if (typeof errorMessage === 'string' && errorMessage && errorMessage !== (message ?? '').trim()) {
    result.detail = errorMessage;
  }
  return result;
}

/** True when `message` names a failure without explaining it. */
export function isGenericFailureMessage(message: string | null | undefined): boolean {
  return GENERIC_MESSAGES.has((message ?? '').trim());
}

@Pipe({name: 'processFailureDetail', standalone: true})
export class ProcessFailureDetailPipe implements PipeTransform {
  transform(data: string | null | undefined, message: string | null | undefined): ProcessFailureDetail {
    return processFailureDetail(data, message);
  }
}
